import React from 'react';
import PropTypes from 'prop-types';
import { Panel, DropdownButton, MenuItem } from 'react-bootstrap';
import DeviceMapCanvas from './DeviceMapCanvas';
import './DeviceMapPanel.scss';

const getLegendItems = colorMode => {
  if (colorMode === 'content') {
    return [
      { key: 'current', label: 'Current' },
      { key: 'downloading', label: 'Downloading' },
      { key: 'pending', label: 'Pending' },
      { key: 'outdated', label: 'Outdated' },
    ];
  }

  return [
    { key: 'online', label: 'Online' },
    { key: 'warning', label: 'Warning' },
    { key: 'offline', label: 'Offline' },
  ];
};

export default function DeviceMapPanel({
  colorMode,
  onColorModeChange,
  dataUrl,
  pollIntervalMs,
  totalPollIntervalMs,
  showSummary,
  className,
  mapClassName,
}) {
  const legendItems = getLegendItems(colorMode);

  return (
    <Panel className={['device-map-panel', className].filter(Boolean).join(' ')}>
      <Panel.Heading className="device-map-panel__heading">
        <span className="poppins-bold font-700 text-[16px]">Devices Map</span>
        <DropdownButton
          id="devices-map-color-mode"
          bsSize="xsmall"
          title={colorMode === 'content' ? 'Content' : 'Status'}
          onSelect={onColorModeChange}
        >
          <MenuItem eventKey="status">Status</MenuItem>
          <MenuItem eventKey="content">Content</MenuItem>
        </DropdownButton>
        <div className="device-map-panel__legend">
          {legendItems.map(item => (
            <span key={item.key} className="device-map-panel__legend-item">
              <span className={`device-map-panel__dot device-map-panel__dot--${item.key}`} />
              {item.label}
            </span>
          ))}
        </div>
      </Panel.Heading>
      <Panel.Body className="device-map-panel__body">
        <DeviceMapCanvas
          className={mapClassName}
          colorMode={colorMode}
          dataUrl={dataUrl}
          pollIntervalMs={pollIntervalMs}
          totalPollIntervalMs={totalPollIntervalMs}
          showSummary={showSummary}
        />
      </Panel.Body>
    </Panel>
  );
}

DeviceMapPanel.propTypes = {
  colorMode: PropTypes.oneOf(['status', 'content']).isRequired,
  onColorModeChange: PropTypes.func,
  dataUrl: PropTypes.string,
  pollIntervalMs: PropTypes.number,
  totalPollIntervalMs: PropTypes.number,
  showSummary: PropTypes.bool,
  className: PropTypes.string,
  mapClassName: PropTypes.string,
};

DeviceMapPanel.defaultProps = {
  onColorModeChange: null,
  dataUrl: null,
  pollIntervalMs: 15000,
  totalPollIntervalMs: null,
  showSummary: false,
  className: null,
  mapClassName: null,
};
